import { useEffect } from 'react';
import useFlashMessage from '@/hooks/useFlashMessage';
import useQueryParams from '@/utility/navigation/useQueryParams';

export enum RedirectMsgType {
  DelegateInvite = 'delegate_invite',
  DelegateRequest = 'delegate_request',
  TripInvite = 'trip_invite',
}

const RedirectMsg = {
  [RedirectMsgType.DelegateInvite]: 'Log in or sign up to respond to an invite for delegate access.',
  [RedirectMsgType.DelegateRequest]: 'Log in or sign up to respond to a request for delegate access.',
  [RedirectMsgType.TripInvite]: 'Log in or sign up to respond to a trip invite.',
};

/**
 * useRedirectMsg
 *
 * When a user is sent a link to a protected page (ie. Delegate invite) but they are not logged in,
 * we want to redirect them to the Sign In page but display a helpful message so that they know what they were linked to
 *
 * This helper defines constants and messaging to be used when displaying these messages
 */
const useRedirectMsg = (): void => {
  const { addFlashMessage } = useFlashMessage();
  const { queryParams } = useQueryParams();
  const from = queryParams?.from;

  useEffect(() => {
    if (from?.length) {
      const redirectMsg = RedirectMsg[from];
      if (redirectMsg) {
        addFlashMessage('warning', redirectMsg);
      }
    }
  }, [from]);
};

export type RedirectMsgParam = 'delegate_invite' | 'delegate_request' | 'trip_invite';

export default useRedirectMsg;
